import {
  Component,
  Input,
  OnChanges,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
} from '@angular/core';

import { Sort, MatSort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';

import { User } from '../manage-access.model';

import { DialogUserViewAccessComponent } from '../dialog-user-view-access/dialog-user-view-access.component';

@Component({
  selector: 'cigna-table-review-confirm',
  templateUrl: './table-review-confirm.component.html',
  styleUrls: ['./table-review-confirm.component.scss'],
})
export class TableReviewConfirmComponent implements OnChanges {
  sortedData: User[];

  @Input() users: User[];
  @Input() selectedPrintEmailUsers: User[];
  @Input() userType: string;
  @Input() tableView = 'confirm';
  @Input() isVendorSuccess = true;
  @Input() shouldShowPrefLob = false;
  @Input() hasManageUserAccessNewExp = false;

  @Output() userSelected = new EventEmitter();
  @Output() usersToggleAll = new EventEmitter();

  @ViewChild('tableElement', { read: ElementRef, static: true })
  private tableElement: ElementRef;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(public dialog: MatDialog) {}

  ngOnChanges() {
    this.sortedData = this.users;
    if (this.tableView === 'confirm') {
      this.selectAllCheck(); // not sure best place for this...
    }
  }

  openUserAccessDialog(user: User) {
    this.dialog.open(DialogUserViewAccessComponent, {
      data: {
        user,
        showEdit: false,
      },
      autoFocus: false,
      width: '700px',
    });
  }

  selectedForPrintEmail(user: User): boolean {
    return this.selectedPrintEmailUsers
      ? this.selectedPrintEmailUsers.findIndex((u) => u.id === user.id) !== -1
      : false;
  }

  selectAllCheck(): void {
    const rowsTotal = this.users.length;
    const headerCheckbox =
      this.tableElement.nativeElement.querySelector('thead th input');
    const rowsChecked = this.tableElement.nativeElement.querySelectorAll(
      'tbody tr input:checked',
    );

    if (rowsChecked === null || headerCheckbox === null) {
      return;
    }

    if (
      rowsChecked.length === rowsTotal &&
      rowsTotal !== 0 &&
      !headerCheckbox.checked
    ) {
      headerCheckbox.checked = true;
    }
    if (
      (rowsChecked.length !== rowsTotal || rowsTotal === 0) &&
      headerCheckbox.checked
    ) {
      headerCheckbox.checked = false;
    }
  }

  selectUser(user: User, event: any): void {
    const checked = event.target.checked;

    this.userSelected.emit({
      user,
      checked,
    });

    this.selectAllCheck();
  }

  selectAllUsers(event: any): void {
    const checked = event.target.checked;

    // set checkbox state in table
    const rowCheckboxes =
      this.tableElement.nativeElement.querySelectorAll('tbody tr input');
    if (checked) {
      rowCheckboxes.forEach((input: HTMLInputElement) => {
        if (!input.checked) {
          input.checked = true;
        }
      });
    } else {
      rowCheckboxes.forEach((input: HTMLInputElement) => {
        if (input.checked) {
          input.checked = false;
        }
      });
    }

    // emit event to clear or select all in reducer
    this.usersToggleAll.emit(checked);
  }

  sortData(sort: Sort): void {
    const data = this.users.slice();
    if (!sort.active || sort.direction === '') {
      this.sortedData = data;
      return;
    }

    data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      // TODO: resolve CHCP disables by bot
      // eslint-disable-next-line sonarjs/no-small-switch
      switch (sort.active) {
        case 'lastName':
          return compare(a.lastName, b.lastName, isAsc);
        default:
          return 0;
      }
    });
    this.sortedData = data;
  }
}

function compare(a: string, b: string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
